export default "__VITE_ASSET__b5714666__"